import { default as UUID } from "node-uuid"
import { SCALAR_TYPES } from "src/libs/scalars"
import { CARD_FIELD_TYPE, CardFiled, ICard, ILandingSection, LANDING_TYPE_CONTENT, SheduleFields, ShedulesContent } from "src/modules/pe-landing-module/data/interfaces"
import Cards from "./Cards"
import Dummy from "./Dummy"
import shedules from "src/modules/pe-landing-module/data/defaults/shedules"

/* Protopia Ecosystem component */
export interface IShedulesProps {
   section:ILandingSection
   data: ShedulesContent
} 

// Dictionary for used card fields type 
export const ShedulesFieldType  = (): any => ({ 
    icon : CARD_FIELD_TYPE.ICON,
    time: CARD_FIELD_TYPE.TIME,
    canvas: CARD_FIELD_TYPE.CANVAS,
    thumbnail : CARD_FIELD_TYPE.IMAGE,
    eventTypeName: SCALAR_TYPES.HTML,
    status: SCALAR_TYPES.HTML,
    title: SCALAR_TYPES.TITLE, 
    description : SCALAR_TYPES.HTML,
    links : CARD_FIELD_TYPE.PERSONAL_LINKS,
    moreButton : CARD_FIELD_TYPE.INNER_LINK || CARD_FIELD_TYPE.OUTER_LINK,
    divider : CARD_FIELD_TYPE.DIVIDER,
    statistic_line: CARD_FIELD_TYPE.STATISTIC_LINE,
    checkbox: CARD_FIELD_TYPE.CHECK_BOX,
    person : CARD_FIELD_TYPE.PERSON,
    order : CARD_FIELD_TYPE.ORDER,
    buttons: CARD_FIELD_TYPE.BUTTONS,
})

const Shedules = (props: IShedulesProps): JSX.Element => {
    const data: ShedulesContent = {
        ...props.data,
        ...( 
            !!props.data.design_type
                ?
                shedules()[ props.data.design_type - 1 ]
                :
                {}
        )
    }
    const { order, cards, card_fields } = data
    
    const getCardFields = ( card_fields: SheduleFields ) : CardFiled[] => {
        let arr: any[] = order.map((key: keyof SheduleFields) => {  
            const field: CardFiled = {
                id: UUID.v4(),
                ...card_fields[key],
                type: ShedulesFieldType()[key],
                pseudonym: key
            }            
            return field
        })
        return arr
    }
    const getCards = (): ICard[] => {
        let arr: [] = cards.map(( card: any, i:number ) => { 
            return {
                i,
                ...card,
                value: order.map((o: string, ii: number) => ({
                    id: o + "-" + i + "-" + ii,
                    ...card[o]
                }))
            }
        }) 
        return arr
    }
    const getData = ( card_fields: SheduleFields ): any => { 
        const personalLinkType: any = {
            ...data,
            card_fields: getCardFields( card_fields ),
            cards: getCards()
        }        
        return personalLinkType
    }
    
    return !!Object.keys(order || {}).length && !!cards.length
        ?
        <Cards 
            section={props.section}
            data={ getData( card_fields || {} ) }
        />
        :
        <Dummy {...{  
            ...{
                data: {
                    ...data as any,  
                    type: LANDING_TYPE_CONTENT.SHEDULE_CARDS,
                    className: ` ${data.className} landing-shedule-${props.section.id} `
                },
            },
            ...props as any,
        }} />
}
export default Shedules